// @ts-nocheck
'use client';

import { useState } from 'react';
import FarmingBlocksManagement from './FarmingBlocksManagement';
import GroupsManagement from './GroupsManagement';
import SectionIntro from 'components/common/SectionIntro';
import { useTranslation } from 'react-i18next';

const FarmingBlock = () => {
  const { t } = useTranslation();
  const [blockGroups, setBlockGroups] = useState([]);

  const handleBlockGroupsUpdate = updatedBlockGroups => {
    setBlockGroups(updatedBlockGroups);
  };

  return (
    <div className="min-h-screen p-6 text-slate-100">
      <SectionIntro
        kicker={t('pageIntro.managementKicker')}
        title={t('nav.farmingBlock')}
        description={t('pageIntro.farmingBlockDescription')}
      />

      <hr className="workspace-summary-divider my-5 border-t" />

      {/* Farming Blocks Management Section */}
      <FarmingBlocksManagement
        blockGroups={blockGroups}
        onRefreshBlockGroups={handleBlockGroupsUpdate}
      />

      {/* Groups Management Section */}
      <GroupsManagement onBlockGroupsUpdate={handleBlockGroupsUpdate} />
    </div>
  );
};

export default FarmingBlock;
